import React, { Fragment, useEffect, useState } from "react";
import styles from "./chat-window.module.less";
import ChatTime from "../../components/chat-time/index";
import {useSelector, useDispatch} from "react-redux";
import { getChatMsgList, getShowLoading, getActiveContext } from "../../reducers/chat-msg-reducer";
import ChatUserMsg from "../../components/chat-user-msg/index";
import ChatBuddyMsg from "../../components/chat-buddy-msg/index";
import {USER_MSG, BUDDY_MSG, BUDDY_COMMON, CONFIG, TRIGGER_DOWNTIME_INTENT, CLICKED_WELCOME} from "../../common/config";
import ChatBuddyCommon from "../chat-buddy-common/chat-buddy-common";
import loadingImg from "@/assets/loading-64px.svg";
import { getScheduleSecurityAlert, getSecurityAlert, getSecurityAlertEndTime, getSecurityAlertStartTime } from "../../reducers/chat-common-reducer";
import { getFilterChatbotSuggestionList } from "../../reducers/chat-suggestion-reducer";
import ReactHtmlParser from "react-html-parser";
import { ChatMsg, DetectIntentData } from "src/types/chat-msg-types";

const ChatWindow: React.FC = () => {
    const chatMsgList = useSelector(getChatMsgList);
    const showLoading = useSelector(getShowLoading);
    const activeContext = useSelector(getActiveContext);
    const securityAlert: string = useSelector(getSecurityAlert);
    const chatContent = React.createRef<HTMLDivElement>();
    const filterChatbotSuggestionList = useSelector(getFilterChatbotSuggestionList);
    const scheduleSecurityAlert: boolean = useSelector(getScheduleSecurityAlert);
    const securityAlertStartTime: Date = new Date(useSelector(getSecurityAlertStartTime));
    const securityAlertEndTime: Date = new Date(useSelector(getSecurityAlertEndTime));
    const [showSecurityAlert, setShowSecurityAlert] = useState<boolean>(false);
    const [securityAlertTimer, setSecurityAlertTimer] = useState(undefined);

    useEffect(() => {
        let lastEle = document.getElementsByClassName("chat-last-msg")[0] as HTMLElement;
        const lastChatMsg: ChatMsg = chatMsgList.chatMsg[chatMsgList.chatMsg.length - 1];
        const noNeedScrollDownTime = (chatMsgList.chatMsg[chatMsgList.chatMsg.length - 2]?.intentType == TRIGGER_DOWNTIME_INTENT && chatMsgList.chatMsg[chatMsgList.chatMsg.length - 1]?.intentType == CLICKED_WELCOME);
        const noNeedScrollAutoTrigger = (CONFIG.UNACTIVITY_TRIGGER == lastChatMsg?.parentQuery || CONFIG.NOEND_CHAT == lastChatMsg?.parentQuery || CONFIG.NOEND_CHINESE_CHAT === lastChatMsg?.parentQuery);
        const noNeedScroll = (securityAlert && securityAlert != '' && chatMsgList.chatMsg.length === 1) || noNeedScrollAutoTrigger || noNeedScrollDownTime;
        if (chatContent.current && !noNeedScroll) {
            //wether there is a scroll bar or not
            if(chatContent.current.scrollHeight > chatContent.current.clientHeight) {
                chatContent.current.scrollTo({
                    top: lastEle ? lastEle.offsetTop - 10 : chatContent.current.scrollHeight,
                    behavior: "smooth",
                });
            }
        }
    }, [chatMsgList.chatMsg.length]);

    useEffect(() => {
        if(filterChatbotSuggestionList && filterChatbotSuggestionList.length > 0) {
            if (chatContent.current) {
                //wether there is a scroll bar or not
                if(chatContent.current.scrollHeight > chatContent.current.clientHeight) {
                    chatContent.current.scrollTo({
                        top: chatContent.current.scrollHeight,
                        behavior: "smooth",
                    });
                }
            }
        }
    }, [filterChatbotSuggestionList,showLoading]);

    /*
    Original Behaviour: Always shown
    if scheduleSecurityAlert is not selected - maintains original behaviour
    If scheduleSecurityAlert is selected, but no start/end date specified - maintain original behaviour
        >If start selected, end unselected - securityAlert starts from specified datetime onwards
        >If start unselected, end selected - securityAlert lasts till end datetime
        >If both selected, securityAlert appears throughout selected time
    */
    useEffect(() => {
        if(scheduleSecurityAlert) {
            startTimer();
        } else {
            setShowSecurityAlert(true)
            clearInterval(securityAlertTimer)
        }   
    }, [scheduleSecurityAlert]);
    
    const startTimer = () => {
        if (securityAlertTimer) {
            clearInterval(securityAlertTimer)
        }
        const timer = setInterval(() => {
                let currentDate = new Date();
                if(currentDate <= securityAlertStartTime) { //hasnt started
                    setShowSecurityAlert(false)
                } 
                else if (currentDate >= securityAlertStartTime && currentDate <= securityAlertEndTime){ //started
                    setShowSecurityAlert(true);
                }
                else{ //ended, close timer
                    setShowSecurityAlert(false);
                    clearInterval(timer) //dismount
                }
        }, 1000);
        setSecurityAlertTimer(timer);
    };

    let height = (filterChatbotSuggestionList?.length > 0) ? filterChatbotSuggestionList.length : 0;
    return (

        <div className={`${styles.ChatWindowLess} height${height}`} ref={chatContent} data-testid="chat-window">
            {
                showSecurityAlert && securityAlert && <Fragment>
                    <div className="security-alert border-radius buddy-style">
                        {ReactHtmlParser(securityAlert)}
                    </div>
                    <ChatTime></ChatTime>
                </Fragment>
            }
            <Fragment>
                {
                    chatMsgList.chatMsg.map((item, index) => {
                        if (item.type === USER_MSG) {
                            return <div key={index} className={index===chatMsgList.chatMsg.length-1?"chat-last-msg chat-user clearfix":"chat-user clearfix"}>
                                <ChatUserMsg userMsg={item.msg} date={item.date}></ChatUserMsg>
                            </div>
                        } else if (item.type === BUDDY_MSG) {
                            const msg = item.msg as DetectIntentData;
                            let disable = false;
                            if(activeContext == null && msg.intentContext) {
                                disable = true;
                            }
                            if(msg && msg.intentContext && activeContext) {
                                msg.intentContext.forEach(context => {
                                    if(activeContext.indexOf(context) == -1) {
                                        disable = true;
                                    }
                                });
                            }

                            return <div className={index===chatMsgList.chatMsg.length-1?"chat-last-msg":""} key={index} ><ChatBuddyMsg intentType={item.intentType} buddyMsg={item.msg} date={item.date} isHistoryMsg={item.isHistoryMsg} disableBtn={disable} convId={item.convId}></ChatBuddyMsg></div>
                        } else if (item.type === BUDDY_COMMON) {
                            return <div className={index===chatMsgList.chatMsg.length-1?"chat-last-msg":""} key={index} ><ChatBuddyCommon buddyCommon={item.msg} date={item.date}></ChatBuddyCommon></div>
                        }
                    })
                }
            </Fragment>
            {
                <div hidden={!showLoading} className="loading-icon">
                    <img src={loadingImg} alt="loading" />
                </div>
            }
        </div>
    )
}

export default ChatWindow;
